<style scoped>
	.contUsBox{margin-right: 20px;width: 240px;z-index: 999;font-size: 13px;}
	.contUsTit{width: 240px; /*background-color: rgb(92, 93, 93);*/color: #fff;font-weight: bold;text-align: center;padding: 15px 0 0 0;border-top-left-radius: 10px; border-top-right-radius: 10px;}
	.contUsTit p{margin: 0;padding: 0;}
	.concatFBox{background-color: #fff;color: #333;width: 100%;padding: 3px 3px 20px 3px; border: 1px solid #ccc;box-shadow: 0px 2px 2px #ccc;box-sizing: border-box;}
	.concat_item{width: 100%;display: flex;flex-direction: row;margin-top: 5px;font-weight: 400;}
	.concat_item_label{position: relative; width: 60px;min-width: 60px; text-align-last: justify;text-align: justify;text-justify: distribute-all-lines;padding-right: 15px;word-spacing: normal;}
	.concat_item_val{text-align: left;}
	.concat_item_label::after{ content: ":"; position: absolute; top: 0; bottom: 0; margin: auto; right: 5px;}
	.concat_item_val p{padding: 3px 0;}
	.clfy{ background-color: #fff;color: #888888; z-index: 999;padding-left: 10px;}
	.clfy,.clfy li{list-style: none; margin: 0;padding: 0;}
	.clfy li{ padding: 0 0;cursor: pointer;margin-top: 5px;position: relative;height: 50px;}
	.clfy li:hover{ color: #333333;transform: scale(1.12);}
	.li_text{display: block; position: absolute;left: 0;right: 0;top: 0;bottom: 0;margin: auto;line-height: 50px;}

</style>
<template>
	<div class="temp">
		<div class="contUsBox">
			<div class="contUsTit" style="z-index: 10;">
				<!--<p>CONTACT US</p>
				<p style="padding-bottom: 15px;">联系我们</p>-->
				<div class="concatFBox" style="position: relative;height: 275px;padding: 0;">
					<img style="width: 100%;height: 100%;" src="../../../assets/004.png" />
					<div class="concon" style="position: absolute;top: 0;left: 0;width: 100%;padding: 0 12px;box-sizing: border-box;">
						<div class="head" style="height: 40px;margin-bottom: 22px;">
							<p style="line-height: 20px;font-size: 0.1rem;opacity: 0;">CONTACT US</p>
							<p style="padding-bottom: 15px;line-height: 20px;text-align: center;font-size: 16px;color: #fff;">联系我们</p>
						</div>
						<div class="concat_item" v-if="concatUsObj.link_man">
							<div class="concat_item_label">联系人</div>
							<div class="concat_item_val">{{concatUsObj.link_man}}</div>
						</div>
						<div class="concat_item" v-if="concatUsObj.phone">
							<div class="concat_item_label">手机</div>
							<div class="concat_item_val">{{concatUsObj.phone}}</div>
						</div>
						<div class="concat_item" v-if="concatUsObj.landline">
							<div class="concat_item_label">座机</div>
							<div class="concat_item_val">{{concatUsObj.landline}}</div>
						</div>
						<div class="concat_item" v-if="concatUsObj.cz">
							<div class="concat_item_label">传真</div>
							<div class="concat_item_val">{{concatUsObj.cz}}</div>
						</div>
						<div style="height: 3px;"></div>
						<div class="concat_item" v-if="concatUsObj.qq">
							<div class="concat_item_label">Q Q</div>
							<div class="concat_item_val">
								<p v-for="qq in concatUsObj.qq">{{qq}}</p>
							</div>
						</div>
						<div style="height: 3px;"></div>
						<div class="concat_item" v-if="concatUsObj.email">
							<div class="concat_item_label">邮箱</div>
							<div class="concat_item_val">
								<p v-for="em in concatUsObj.email">{{em}}</p>
							</div>
						</div>
						<div class="concat_item">
							<div class="concat_item_label" v-if="concatUsObj.address">地址</div>
							<div class="concat_item_val">{{concatUsObj.address}}</div>
						</div>
					</div>

				</div>
				<ul class="clfy" v-if="clasType==1">
					<li @click="changeNew(9)">
						<img src="../../../assets/001.png" style="width: 100%;height: 100%;" />
						<div class="li_text">设计诊断</div>
					</li>
					<li @click="changeNew(10)">
						<img src="../../../assets/001.png" style="width: 100%;height: 100%;" />
						<div class="li_text">品牌创新</div>
					</li>
					<li @click="changeNew(11)">
						<img src="../../../assets/001.png" style="width: 100%;height: 100%;" />
						<div class="li_text">市场机遇</div>
					</li>
					<li @click="changeNew(12)">
						<img src="../../../assets/001.png" style="width: 100%;height: 100%;" />
						<div class="li_text">设计众筹</div>
					</li>
					<li @click="changeNew(4)">
						<img src="../../../assets/001.png" style="width: 100%;height: 100%;" />
						<div class="li_text">设计众包</div>
					</li>
					<li @click="changeNew(13)">
						<img src="../../../assets/001.png" style="width: 100%;height: 100%;" />
						<div class="li_text">小贷试产</div>
					</li>
					<li @click="changeNew(14)">
						<img src="../../../assets/001.png" style="width: 100%;height: 100%;" />
						<div class="li_text">共享设备</div>
					</li>
				</ul>
				<ul class="clfy" v-if="clasType==2">
					<li @click="changeNew(5)">
						<img src="../../../assets/001.png" style="width: 100%;height: 100%;" />
						<div class="li_text">新闻资讯</div>
					</li>
					<li @click="changeNew(16)">
						<img src="../../../assets/001.png" style="width: 100%;height: 100%;" />
						<div class="li_text">关于我们</div>
					</li>
				</ul>
				<ul class="clfy" v-if="clasType==3">
					<li @click="changeNew(1)">
						<img src="../../../assets/001.png" style="width: 100%;height: 100%;" />
						<div class="li_text">产业孵化</div>
					</li>
					<li @click="changeNew(12)">
						<img src="../../../assets/001.png" style="width: 100%;height: 100%;" />
						<div class="li_text">知识产权</div>
					</li>
					<li @click="changeNew(19)">
						<img src="../../../assets/001.png" style="width: 100%;height: 100%;" />
						<div class="li_text">金融服务</div>
					</li>
					<li @click="changeNew(20)">
						<img src="../../../assets/001.png" style="width: 100%;height: 100%;" />
						<div class="li_text">项目申报</div>
					</li>
					<li @click="changeNew(21)">
						<img src="../../../assets/001.png" style="width: 100%;height: 100%;" />
						<div class="li_text">其他服务</div>
					</li>
				</ul>
				<ul class="clfy" v-if="clasType==5">
					<li @click="changeNew(3)">
						<img src="../../../assets/001.png" style="width: 100%;height: 100%;" />
						<div class="li_text">赛事展会</div>
					</li>
					<li @click="changeNew(23)">
						<img src="../../../assets/001.png" style="width: 100%;height: 100%;" />
						<div class="li_text">业内资讯</div>
					</li>
				</ul>
				<ul class="clfy" v-if="clasType==6">
					<li @click="changeNew(6)">
						<img src="../../../assets/001.png" style="width: 100%;height: 100%;" />
						<div class="li_text">本地政策</div>
					</li>
					<li @click="changeNew(25)">
						<img src="../../../assets/001.png" style="width: 100%;height: 100%;" />
						<div class="li_text">国内政策</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		inject: ['reload'], //注入App里的reload方法
		props:['pageParam'],
		data() {
			return {
				concatUsObj: {},
				clasType:0,
			}
		},
		created: function() {
			let _this = this;
			_this.getConcatUs();
			_this.clasType = _this.pageParam;
		},
		mounted: function() {
			let _this = this;
		},
		methods: {
			/*__方法描述 _______________autor:郑凯____creat-time:2019-12-19 13:15*/
			/*获取联系方式
			 创建于2020-2-12  作者：郑凯*/
			getConcatUs() {
				let _this = this;
				let paramsObj = {};
				_this.$axios({
					method: 'get',
					url: '/api/getContactInfo',
					headers: {},
					params: paramsObj
				}).then((response) => {
					let resObj = response.data;
					//console.log(JSON.stringify(resObj)) //请求成功返回的数据
					if(resObj.status == '00') {
						_this.concatUsObj = resObj.data;
						if(resObj.data.qq) {
							let strArr = resObj.data.qq.split("|");
							_this.concatUsObj.qq = strArr;
						}
						if(resObj.data.email) {
							let strArr = resObj.data.email.split("|");
							_this.concatUsObj.email = strArr;
						}
					} else if(resObj.status == 1001) {

					}
				}).catch((error) => {
					return false;
				});
			},

			/*切换新闻
			 创建于2020-2-12  作者：郑凯*/
			changeNew(type) {
				let _this = this;
				_this.reload();
				_this.$router.push({
					name: 'newsList',
					query: {
						class_id: type,
						clasType:_this.clasType
					}
				});
			},
		}
	}
</script>